import React, { FC } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';

import { FlexRow } from '../../layouts/FlexRow';
import { CheckboxFieldProps } from './types';

const StyledCheckboxField = styled(FlexRow, {
  shouldForwardProp,
  // TODO: find a way to use AsHTMLProps with FlexRow and generics
})<CheckboxFieldProps & { as?: keyof JSX.IntrinsicElements }>(
  css({
    alignItems: 'flex-start',
    cursor: 'pointer',
    opacity: 1,
    width: '100%',
    position: 'relative',
    gap: 'checkbox.fromLabel',
  })
);

const CheckboxField = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof StyledCheckboxField>
>(({ as = 'label', ...props }, ref) => (
  <StyledCheckboxField as={as} ref={ref} {...props} />
));

CheckboxField.propTypes = {
  disabled: PropTypes.bool,
};

export default CheckboxField;
